function AppealHero() {
    let appealHero = document.querySelector('.appeal-hero');

    if (!appealHero) {
        return;
    }

    function toggleAppealHeroFixed() {
        let rect = appealHero.getBoundingClientRect();

        if (rect.top <= 0) {
            appealHero.classList.add('appeal-hero--fixed');
        } else {
            appealHero.classList.remove('appeal-hero--fixed');
        }
    }

    window.addEventListener('scroll', toggleAppealHeroFixed);
    window.addEventListener('resize', toggleAppealHeroFixed);

    toggleAppealHeroFixed();
}

export default AppealHero;
